import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    SimpleGrid,
    Text,
    Image,
    Button,
    Divider,
    Flex,
    useMultiStyleConfig,
    useMediaQuery,
} from '@chakra-ui/react'
import {remCalc} from '../../theme/_utils'
import {ChevronDownIcon} from '@chakra-ui/icons'
import {FormattedMessage} from 'react-intl'
import {getDamBaseUrl} from '../../custom-hooks/use-dam-image'

const WhatsInTheBox = ({items, variant = 'default'}) => {
    const [isMobile] = useMediaQuery(`(max-width: ${remCalc(767)})`)
    const [isTablet] = useMediaQuery(`(max-width: ${remCalc(1023)})`)
    const maxVisibleItems = isMobile ? 6 : isTablet ? 8 : 14
    const [showAll, setShowAll] = useState(false)
    const visibleItems = showAll ? items : items.slice(0, maxVisibleItems)
    const hasMore = items.length > maxVisibleItems

    // Use styles from RecommendedProducts theme
    const styles = useMultiStyleConfig('WhatsInTheBox', {variant})
    const baseUrl = getDamBaseUrl()

    return (
        <Flex {...styles.backgroundContainer}>
            <Flex {...styles.outerContainer} data-testid="whats-in-the-box">
                <Text as="h2" {...styles.headerLabel}>
                    <FormattedMessage
                        defaultMessage="What's in the box"
                        id="whats_in_the_box.heading"
                    />
                </Text>
                <SimpleGrid {...styles.elementsGrid}>
                    {visibleItems.map((item, idx) => (
                        <Box key={idx} {...styles.elementContainer}>
                            <Image
                                src={`${baseUrl}/${item?.imageLink}`}
                                alt={item.title}
                                {...styles.elementImage}
                            />
                            <Text sx={styles.itemLabel}>{item.title}</Text>
                        </Box>
                    ))}
                </SimpleGrid>
                {hasMore && !showAll && (
                    <Box textAlign="center" mt={6}>
                        <Button sx={styles.showAllButton} onClick={() => setShowAll(true)}>
                            <FormattedMessage
                                defaultMessage="Show all"
                                id="whats_in_the_box.button.show_all"
                            />
                            <ChevronDownIcon w={remCalc(24)} h={remCalc(24)} />
                        </Button>
                    </Box>
                )}
                <Box width="100%" px={{base: 4, md: 6}}>
                    <Divider mt={8} />
                </Box>
            </Flex>
        </Flex>
    )
}

WhatsInTheBox.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            image: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
        }),
    ).isRequired,
    variant: PropTypes.string,
}

export default WhatsInTheBox
